import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREAUCT_Pool_Escrow_Setup.css';

const PREAUCT_Pool_Escrow_Setup = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREAUCT_POOL_ESCROW_SETUP",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREAUCT_POOL_ESCROW_SETUP:-1
  });


  const [PREAUCT_POOL_ESCROW_SETUP, setPREAUCT_POOL_ESCROW_SETUP] = React.useState(null);
  const [PREAUCT_POOL_ESCROW_SETUP_D, setPREAUCT_POOL_ESCROW_SETUP_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Pool Escrow Setup');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREAUCT_POOL_ESCROW_SETUP(clientInfo,"OpenNew");

		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREAUCT_POOL_ESCROW_SETUP(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREAUCT_POOL_ESCROW_SETUP(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREAUCT_POOL_ESCROW_SETUP(clientInfo,"OpenNew");
		}
		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
		if(Temp_Data2.status!="New"){
			handleDeletePREAUCT_POOL_ESCROW_SETUP(Temp_Data2);
			navigate('/PREAUCT_Pool_Escrow_Setup#New',{replace:true});
		} 
		else 
			navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Pool_Escrow_Setup',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREAUCT_POOL_ESCROW_SETUP) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREAUCT_POOL_ESCROW_SETUP]) ;


  
  
  var Ids = [];
  for(var Ele in PREAUCT_POOL_ESCROW_SETUP){
	  for(var Sec in PREAUCT_POOL_ESCROW_SETUP[Ele]){
		if(Sec == "id")
			Ids.push(PREAUCT_POOL_ESCROW_SETUP[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREAUCT_POOL_ESCROW_SETUP[Ele]["status"]);
		else if(Array.isArray(PREAUCT_POOL_ESCROW_SETUP[Ele][Sec]))
			  for(var Row in PREAUCT_POOL_ESCROW_SETUP[Ele][Sec])  // Convert to PREAUCT_POOL_ESCROW_SETUP[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREAUCT_POOL_ESCROW_SETUP[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREAUCT_POOL_ESCROW_SETUP"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREAUCT_POOL_ESCROW_SETUP(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP`).then((response1) => {
		if(!PREAUCT_POOL_ESCROW_SETUP) 
			setPREAUCT_POOL_ESCROW_SETUP(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP_D`).then((response2) => {
			setPREAUCT_POOL_ESCROW_SETUP_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREAUCT_POOL_ESCROW_SETUP_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREAUCT_POOL_ESCROW_SETUP = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREAUCT_POOL_ESCROW_SETUP(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREAUCT_POOL_ESCROW_SETUP = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREAUCT_POOL_ESCROW_SETUP = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREAUCT_POOL_ESCROW_SETUP = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREAUCT_POOL_ESCROW_SETUP = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_POOL_ESCROW_SETUP', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["1"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["2"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["3"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["3"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
  
      
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["3"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  



const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["4"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4"]=value;
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["5"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
  }; 
  

    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
	Temp_Data["9"]["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4"]=value;
	//handleAddPREAUCT_POOL_ESCROW_SETUP(Temp_Data,App_Data['PREAUCT_POOL_ESCROW_SETUP']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
    setPREAUCT_POOL_ESCROW_SETUP(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREAUCT_POOL_ESCROW_SETUP) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREAUCT_POOL_ESCROW_SETUP =JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
  updatedPREAUCT_POOL_ESCROW_SETUP[Sec] = [...updatedPREAUCT_POOL_ESCROW_SETUP[Sec], newRow];
  setPREAUCT_POOL_ESCROW_SETUP(updatedPREAUCT_POOL_ESCROW_SETUP);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREAUCT_POOL_ESCROW_SETUP = JSON.parse(JSON.stringify(PREAUCT_POOL_ESCROW_SETUP));
  updatedPREAUCT_POOL_ESCROW_SETUP[sec].splice(index, 1);
  setPREAUCT_POOL_ESCROW_SETUP(updatedPREAUCT_POOL_ESCROW_SETUP);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Pre-Auction Pool Escrow Setup`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pre-Auction Pool Escrow ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pool Escrow ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0" type="text" className="form-control" placeholder="PREAUCT Pool Escrow ID" value={PREAUCT_POOL_ESCROW_SETUP["1"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pool Escrow ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Pre Auction Pool ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1" type="text" className="form-control" placeholder="PREAUCT Pre Auction Pool ID" value={PREAUCT_POOL_ESCROW_SETUP["1"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Pre Auction Pool ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Agent ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2" type="text" className="form-control" placeholder="Escrow Agent ID" value={PREAUCT_POOL_ESCROW_SETUP["1"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Agent ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Account ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3" type="text" className="form-control" placeholder="Escrow Account ID" value={PREAUCT_POOL_ESCROW_SETUP["1"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Account ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Escrow Bank Name`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Bank Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0" type="text" className="form-control" placeholder="Escrow Bank Name" value={PREAUCT_POOL_ESCROW_SETUP["2"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Escrow Bank Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Account Last4`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1" type="text" className="form-control" placeholder="Escrow Account Last4" value={PREAUCT_POOL_ESCROW_SETUP["2"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4ch' }}>
						 {t(`Enter Escrow Account Last4`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Agreement Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2" type="text" className="form-control" placeholder="Escrow Agreement Link" value={PREAUCT_POOL_ESCROW_SETUP["2"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Escrow Agreement Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Refund Rules`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Refund Rules`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0" type="text" className="form-control" placeholder="Refund Rules" value={PREAUCT_POOL_ESCROW_SETUP["3"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Refund Rules`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Release Conditions`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1" type="text" className="form-control" placeholder="Release Conditions" value={PREAUCT_POOL_ESCROW_SETUP["3"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Release Conditions`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Dual Approval Required`)} <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2_Change} 
					  checked={PREAUCT_POOL_ESCROW_SETUP?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2"] === "true" || PREAUCT_POOL_ESCROW_SETUP?.["3"]?.["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_3_2"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Escrow Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Escrow Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0"  value={PREAUCT_POOL_ESCROW_SETUP["4"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0`]} onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_4_0_Change} className="form-control" name="Escrow Status"  >
						  <option value="Setup Pending">Setup Pending</option>
						  <option value="Active">Active</option>
						  <option value="Frozen">Frozen</option>
						  <option value="Closed">Closed</option>
						  <option value="Exception">Exception</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Escrow Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0" type="text" className="form-control" placeholder="Submitted By" value={PREAUCT_POOL_ESCROW_SETUP["5"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1" type="text" className="form-control" placeholder="Submitted At" value={PREAUCT_POOL_ESCROW_SETUP["5"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2" type="text" className="form-control" placeholder="Reviewed By" value={PREAUCT_POOL_ESCROW_SETUP["5"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3" type="text" className="form-control" placeholder="Reviewed At" value={PREAUCT_POOL_ESCROW_SETUP["5"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4"  value={PREAUCT_POOL_ESCROW_SETUP["5"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4`]} onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5" type="text" className="form-control" placeholder="Approval Notes" value={PREAUCT_POOL_ESCROW_SETUP["5"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0"  value={PREAUCT_POOL_ESCROW_SETUP["9"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0`]} onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1" type="text" className="form-control" placeholder="Created By" value={PREAUCT_POOL_ESCROW_SETUP["9"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2" type="text" className="form-control" placeholder="Created At" value={PREAUCT_POOL_ESCROW_SETUP["9"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3" type="text" className="form-control" placeholder="Updated By" value={PREAUCT_POOL_ESCROW_SETUP["9"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4" type="text" className="form-control" placeholder="Updated At" value={PREAUCT_POOL_ESCROW_SETUP["9"][`PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4`]} 
						onChange={PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_03_POOL_STRUCTURING_ESCROW_COMPLIANCE_PREAUCT_POOL_ESCROW_SETUP_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREAUCT_Pool_Escrow_Setup;  